import { render, staticRenderFns } from "./TellertoBranch.vue?vue&type=template&id=23756621&scoped=true"
import script from "./TellertoBranch.vue?vue&type=script&lang=js"
export * from "./TellertoBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23756621",
  null
  
)

export default component.exports